import { render, staticRenderFns } from "./GamesByTypeChart.vue?vue&type=template&id=21eca31f&"
import script from "./GamesByTypeChart.vue?vue&type=script&lang=js&"
export * from "./GamesByTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports